import { initialState } from '../../initialState';
import { updateSelections } from '../../utils';

import {
    RACING_RACECARD_UPDATE,
    RACING_RACECARD_UPDATE_FROM_CACHE,
    RACING_RACECARD_UPDATE_SELECTION_PRICE,
} from '../actions/types';

/**
 * Racecard racing widget reducer
 * @param {Object} state the current state
 * @param {Object} action the action
 * @returns {Object} new state
 */
export default function racecardReducer(state = initialState, action) {
    switch (action.type) {
        case RACING_RACECARD_UPDATE: {
            return {
                ...state,
                ...action.raceCardData,
                selected_event_id: action.eventId,
            };
        }

        case RACING_RACECARD_UPDATE_SELECTION_PRICE: {
            const events = action.data;
            let selections = [];

            if(state.selections) {

                for (const event of events) {
                    selections = updateSelections(event, state.selections);
                }
            }

            return {
                ...state,
                selections,
            };
        }
        case RACING_RACECARD_UPDATE_FROM_CACHE: {
            return {
                ...state,
                ...action.raceCard,
            };
        }
        default:
            return state;
    }
}
